import script from "./EventDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./EventDetails.vue?vue&type=script&setup=true&lang=js"

import "./EventDetails.vue?vue&type=style&index=0&id=64560687&lang=css"
import "./EventDetails.vue?vue&type=style&index=1&id=64560687&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64560687"]])

export default __exports__